<template>
  <nav class="header-nav">
    <div class="container">
      <router-link :class="{ active: activeLink == 'company' }" to="/company"
        >企業概要</router-link
      >
      <router-link
        :class="{ active: activeLink == 'intro' }"
        to="/company/intro"
        >企業宗旨、企業理念、事業方針</router-link
      >
      <router-link
        :class="{ active: activeLink == 'philosophy' }"
        to="/company/philosophy"
        >社長的話</router-link
      >
    </div>
  </nav>
</template>
<script>
export default {
  name: "CompanyHeaderNav",
  props: ["activeLink"],
};
</script>